import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { AlertCircle } from 'lucide-react';

export const Login = () => {
  const [key, setKey]         = useState('');
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!key.trim()) { setError('Введите токен доступа'); return; }
    setLoading(true);
    setError('');
    try {
      await login(key.trim());
    } catch {
      setError('Неверный токен — проверьте ADMIN_TOKEN в .env сервера');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}>
      <div className="bg-image" />
      <div style={{ width: '100%', maxWidth: '380px', position: 'relative', zIndex: 1 }}>

        {/* Brand */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{
            width: '56px', height: '56px', borderRadius: '16px',
            background: 'linear-gradient(135deg, #818cf8, #6366f1)',
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            marginBottom: '16px', fontSize: '24px',
            boxShadow: '0 8px 32px rgba(129,140,248,0.4)',
          }}>⚡</div>
          <p className="text-muted" style={{ fontSize: '13px' }}>Панель администратора</p>
        </div>

        {/* Card */}
        <div className="card" style={{ padding: '28px' }}>
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>

            <div className="field-wrap">
              <span className="field-prefix">🔒</span>
              <input
                type="password"
                placeholder="Admin Token"
                value={key}
                onChange={e => setKey(e.target.value)}
                style={{ paddingLeft: '34px' }}
                autoFocus
              />
            </div>

            {error && (
              <div className="alert alert-error" style={{ fontSize: '12px' }}>
                <AlertCircle size={14} style={{ flexShrink: 0 }} />
                <span>{error}</span>
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="btn btn-primary"
              style={{ justifyContent: 'center', padding: '10px', marginTop: '4px' }}
            >
              {loading ? 'Проверка...' : 'Войти →'}
            </button>
          </form>
        </div>

        <p className="text-dim" style={{ textAlign: 'center', fontSize: '11px', marginTop: '18px' }}>
          NKEY Kiosk · Система управления аппаратами
        </p>
      </div>
    </div>
  );
};
